var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-title',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{class:{'white--text': _vm.$vuetify.theme.dark, 'headline text-uppercase mt-2 text-center': true},attrs:{"cols":"12"}},[_vm._v(_vm._s(_vm.text))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }